import keycloak from "../config/keycloak.jsx";

let redirectingToLogin = false;

export function isRedirectingToLogin() {
  return redirectingToLogin;
}

/**
 * Drops the in-memory session and opens the marketplace sign-in page.
 * Used when Keycloak rejects a refresh token.
 */
export function redirectToMarketplaceLogin() {
  if (redirectingToLogin) return;
  redirectingToLogin = true;

  try {
    if (keycloak?.token && typeof keycloak.clearToken === "function") {
      keycloak.clearToken();
    } else if (keycloak) {
      keycloak.authenticated = false;
      keycloak.token = undefined;
      keycloak.refreshToken = undefined;
      keycloak.tokenParsed = undefined;
    }
  } catch {
    // Listeners notified by clearToken may navigate as well.
  }

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
}
